import appGlobalScript from '/builds/repos/eon-is/frontend/eon-ui/eon-ui-components/src/globals/global.ts';
export const globalScripts = appGlobalScript;
